import { ResultsPostRequest } from '@/dtos/resolutions/gm-resolution/results/post'

// Postと同じRequestを使用
export class ResultsPutRequest extends ResultsPostRequest {
}
